/**
 * The searchable select's matching, kept out of the component so it can be tested
 * without a DOM.
 */

export interface ComboboxOption {
  readonly value: string;
  readonly label: string;
}

/**
 * Options whose label holds every word of the query, in any order, ignoring case:
 * "hq phnom" finds "Phnom Penh HQ". Order is kept as given — the caller's order is
 * meaningful (a window list runs short to long), and re-ranking it under the
 * cursor would move the row somebody is about to click.
 */
export function matchOptions<T extends ComboboxOption>(
  options: readonly T[],
  query: string,
): readonly T[] {
  const words = query
    .toLowerCase()
    .split(/\s+/)
    .filter((word) => word !== "");
  if (words.length === 0) return options;
  return options.filter((option) => {
    const label = option.label.toLowerCase();
    return words.every((word) => label.includes(word));
  });
}

/** Where the highlight starts: on the current choice if it is listed, else the top. */
export function initialActive(options: readonly ComboboxOption[], value: string): number {
  if (options.length === 0) return -1;
  const index = options.findIndex((option) => option.value === value);
  return index === -1 ? 0 : index;
}
